import { FunctionComponent } from 'react';
import * as s from './FourthStepItem.css';
import * as T from './FourthStepItem.types';
import Button from '@media-ui/core/src/components/Button';
import Link from '@media-ui/core/src/components/Link';
import Text from '@media-ui/core/src/components/Text';
const FourthStepItem: FunctionComponent<T.FourthStepItemProps> = ({ title, subtitle, icon, facts, link, children, }) => (<Link target="_blank" href={link} className={s.root}>
    <div>{icon}</div>
    <div className={s.wrapper}>
      <div className={s.title}>{title}</div>
      <Text className={s.subtitle}>{subtitle}</Text>
      <div className={s.children}>{children}</div>
      {facts &&
        facts.map((item) => (<Text key={item} className={s.fact}>
            {item}
          </Text>))}
    </div>
    <Button className={s.button} theme="primary">
      Подробнее
    </Button>
  </Link>);
export default FourthStepItem;
